import { handleApiError } from '@/api/common';
import { authService } from '@/auth';
import axios, { AxiosInstance } from 'axios';

const createInstance = async (): Promise<AxiosInstance> => {
	const accessToken = await authService.getAccessToken();
	return axios.create({
		headers: {
			Authorization: `Bearer ${accessToken}`
		}
	});
};

export const get = async <T>(url: string): Promise<T> => {
	try {
		const instance = await createInstance();
		const response = await instance.get<T>(url);
		return response.data;
	} catch (error) {
		throw handleApiError(error);
	}
};

export const post = async <R, T>(url: string, payload?: R): Promise<T> => {
	try {
		const instance = await createInstance();
		const response = await instance.post<T>(url, payload);
		return response.data;
	} catch (error) {
		throw handleApiError(error);
	}
};

export const put = async <R, T>(url: string, payload?: R): Promise<T> => {
	try {
		const instance = await createInstance();
		const response = await instance.put<T>(url, payload);
		return response.data;
	} catch (error) {
		throw handleApiError(error);
	}
};

export const del = async <T>(url: string): Promise<T> => {
	try {
		const instance = await createInstance();
		const response = await instance.delete(url);
		return response.data;
	} catch (error) {
		throw handleApiError(error);
	}
};
